/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FolderInputs */

const cs_enum_folder = /** @type {(inputs: Enum_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Složka`)
};

const en_enum_folder = /** @type {(inputs: Enum_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder`)
};

/**
* | output |
* | --- |
* | "Folder" |
*
* @param {Enum_FolderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_folder = /** @type {((inputs?: Enum_FolderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FolderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_folder(inputs)
	return cs_enum_folder(inputs)
});